import React, { createContext, useEffect, useState } from 'react'

interface IAuthContext {
  children: JSX.Element
}
interface IUserData {
  address: string
  chainId: number
}

const AuthContext = createContext({
  userData: null,
  transferData: null,
  wcProvider: null,
  contract: null,
  setUserDataToContext: (data: IUserData) => {
    // eslint-disable-next-line no-console
    console.log(data)
  },
  setTransferData: (data: IUserData) => {
    // eslint-disable-next-line no-console
    console.log(data)
  },
  setWcProvider: (data: any) => {
    // eslint-disable-next-line no-console
    console.log(data)
  },
  setContract: (data: any) => {
    // eslint-disable-next-line no-console
    console.log(data)
  },
})

const { Provider } = AuthContext

const AuthProvider = ({ children }: IAuthContext) => {
  const [userData, setUserData] = useState<null | IUserData>(null)
  const [transferData, setTransferData] = useState<null | IUserData>(null)
  const [wcProvider, setWcProvider] = useState<null | any>(null)
  const [contract, setContract] = useState<null | any>(null)
  const updateUserData = (data: IUserData) => {
    setUserData(data)
  }
  useEffect(() => {
    if (localStorage.getItem('walletconnect')) {
      const address = JSON.parse(localStorage.getItem('walletconnect')).accounts[0]
      const { chainId } = JSON.parse(localStorage.getItem('walletconnect'))
      setUserData({ address, chainId })
    }
  }, [])
  return (
    <Provider
      value={{
        userData,
        setUserDataToContext: updateUserData,
        transferData,
        setTransferData,
        wcProvider,
        setWcProvider,
        contract,
        setContract,
      }}
    >
      {children}
    </Provider>
  )
}
export { AuthProvider, AuthContext }
